import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import API_URL from "../../localhost/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ModalAsignacionEquipos({ showModal, onHide, turno }) {
  const [dataEquipos, setDataEquipos] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const idTurno = turno?.id;

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const notifyWanr = (mensaje) => {
    toast.warn(mensaje, {
      position: "bottom-right",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  useEffect(() => {
    // Función para obtener las prioridades
    const obtenerPrioridades = async () => {
      try {
        const response = await axios.get(`${API_URL}/getPrioridades`);
        setPrioridades(response.data);
      } catch (error) {
        notifyWanr("Error al obtener prioridades.");
      }
    };

    obtenerPrioridades();
  }, []);

  // useEffect(() => {
  //   if (idTurno) {
  //     const fetchData = async () => {
  //       fetch(`${API_URL}/getTeamsByIdTurno?idTurno=${idTurno}` , headers)
  //         .then((response) => response.json())
  //         .then((data) => {
  //           setDataEquipos(data);
  //         });
  //     };
  //     fetchData();
  //   }
  // }, [idTurno]);

  useEffect(() => {
    if (idTurno) {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/getTeamsByIdTurno?idTurno=${idTurno}`,
            headers
          );
          setDataEquipos(response.data);
        } catch (error) {
          // Manejar el error aquí
          notifyWanr("Error al obtener los equipos.");
        }
      };

      fetchData();
    }
  }, [idTurno]);

  const handleRadioChange = async (equipoId, nuevaPrioridadId) => {
    const url = `${API_URL}/updateAvailability`;

    const data = {
      idEquipo: equipoId,
      prioridad: nuevaPrioridadId,
      idTurno: turno.id,
    };

    try {
      await axios.put(url, data);

      // Actualizar localmente la prioridad del equipo
      setDataEquipos((prevData) =>
        prevData.map((equipo) =>
          equipo.id === equipoId
            ? { ...equipo, Prioridad: nuevaPrioridadId }
            : equipo
        )
      );
    } catch (error) {
      notifyWanr("Error al actualizar la prioridad en la base de datos.");
    }
  };

  return (
    <div>
      <Modal show={showModal} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>
            {`${turno?.dia} a las ${turno?.horario} en ${turno?.cancha}`}
          </Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
          <div
            style={{ maxWidth: "600px", margin: "0 auto", marginTop: "20px" }}
          >
            <table className="table">
              <thead>
                <tr>
                  <th>Equipo</th>
                  {prioridades.map((prioridad, index) => (
                    <th key={index}>{prioridad.Descripcion}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataEquipos?.map((equipo) => (
                  <tr key={equipo.id}>
                    <td>{equipo.Nombre}</td>
                    {prioridades.map((prioridad, index) => (
                      <td key={index}>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`inlineRadioOptions_${equipo.id}`}
                            id={`inlineRadio${index + 1}_${equipo.id}`}
                            value={prioridad.id}
                            checked={equipo.Prioridad === prioridad.id}
                            onChange={() =>
                              handleRadioChange(equipo.id, prioridad.id)
                            }
                          />
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ModalAsignacionEquipos;
